import Styles from "./Mob.module.css"
import { Grid2,Typography,Button,Paper,InputBase } from "@mui/material"
import { useState } from "react";
import validator from "validator"
import { backendHosts } from "../../../../ui-utils/apiConfig";
import  axios  from "axios";
import en from "../../../../i18n/English/Partner/home.json";
import hi from "../../../../i18n/Hindi/Partner/home.json";
import kn from "../../../../i18n/Kannada/Partner/home.json";
import ma from "../../../../i18n/Marathi/Partner/home.json";
import gu from "../../../../i18n/Gujarati/Partner/home.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function BrokerMob() {
    const [formData, setFormData] = useState({
        name: "",
        mobileNo: "",
        email: "",
    });

    const [error, setError] = useState(""); // Stores the single error message
    const [errorField, setErrorField] = useState(""); // Tracks which field has the error
    const [successMsg, setSuccessMsg] = useState("")

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let updatedValue = value;

        if (name === "name") {
            updatedValue = value.replace(/[0-9]/g, ""); // Remove any numeric characters
          }


        if (name === "mobileNo") {
            const numericValue = value.replace(/\D/g, "");
            updatedValue = numericValue.slice(0, 10);
        }

        setFormData((prev) => ({ ...prev, [name]: updatedValue }));

        // Clear error if the user starts typing in the field with the current error
        if (errorField === name) {
            setError("");
            setErrorField("");
        }
    };

    const handleSubmit = async() => {
        // Prioritize validation by order
        if (formData.name.trim().length === 0) {
            setError("Please enter your name.");
            setErrorField("name");
            return;
        } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
            setError("Name should only contain letters and spaces.");
            setErrorField("name");
            return;
        }

        if (formData.mobileNo.trim().length === 0) {
            setError("Please enter your mobile number.");
            setErrorField("mobileNo");
            return;
        } else if (!validator.isMobilePhone(formData.mobileNo, "en-IN")) {
            setError("Please enter a valid mobile number.");
            setErrorField("mobileNo");
            return;
        }

        if (formData.email.trim().length === 0) {
            setError("Please enter your email.");
            setErrorField("email");
            return;
        } else if (!validator.isEmail(formData.email)) {
            setError("Please enter a valid email address.");
            setErrorField("email");
            return;
        }

        // If no errors
        setError("");
        setErrorField("");
        const payload = {
            data: {
                type: "broking partner",
                name: formData.name,
                email: formData.email,
                mobile: formData.mobileNo,
                description: "Requesting to become a partner with Tradeboss",
            }
        }
        const response = await axios.post(`${backendHosts.ADMIN}/api/ticket-tracker/tickets`, payload)
        if (response.data?.data?.status == 200) {
            setFormData({
                name: "",
                mobileNo: "",
                email: "",
            });
            setError("")
            setSuccessMsg("Thank you for providing your details!. Our team will reach out to you shortly.")

        } else {
            setSuccessMsg("")
            setError("Something went wrong. Please try again later.")

        }

      };

    const { language } = useLanguage();
    const translations = { en, hi, kn, ma, gu };
    const t = translations[language];
    return (
        <>
            <Grid2 className={Styles.outerCard}>
         <h1 className={Styles.heading}>
                    {t.heading}
           </h1>
                 <Grid2>
                    <Paper component="form" className={Styles.field}>

                        <InputBase
                            className={Styles.inputbase}
                            name="name"
                            type="name"
                            placeholder={t.formFields.name.placeholder}
                            autoComplete="name"
                            inputProps={{
                                "aria-label": "Name"
                            }}
                            onChange={handleInputChange}
                            value={formData.name}
                        />

                    </Paper>
                    {errorField === "name" && <p className={Styles.errMsgg}>{error}</p>}
                    <Paper component="form" className={Styles.field}>
                        <InputBase
                            className={Styles.inputbase}
                            name="mobileNo"
                            type="tel"
                            placeholder={t.formFields.mobileNo.placeholder}
                            autoComplete="tel"
                            inputProps={{
                                "aria-label": "Phone Number",
                                inputMode: "numeric",
                            }}
                            onChange={handleInputChange}
                            value={formData.mobileNo}
                        />
                    </Paper>
                    {errorField === "mobileNo" && <p className={Styles.errMsgg}>{error}</p>}
                    <Paper component="form" className={Styles.field}>

                        <InputBase
                            className={Styles.inputbase}
                            name="email"
                            type="email"
                            placeholder={t.formFields.email.placeholder}
                            autoComplete="email"
                            inputProps={{
                                "aria-label": "email"
                            }}
                            onChange={handleInputChange}
                            value={formData.email}
                        />

                    </Paper>
                    {errorField === "email" && <p className={Styles.errMsgg}>{error}</p>}
                    {successMsg && (
                            <Typography className={Styles.successMsg}>
                                {successMsg}
                             </Typography>
                        )}
                    <Button
                    className={Styles.button}
                        onClick={handleSubmit}>
                        {t.formFields.buttonText}
                    </Button>


                </Grid2>
                {/* <Typography className={Styles.txt}>
                        CONTACT US
                    </Typography> */}
                <Typography className={Styles.subtxt} margi>
                    {t.contactInfo.text}  Phone: +91 74003 62816 | Email: info@tradeboss.co
                </Typography>
        </Grid2>
        </>
    )
}